export default "__VITE_ASSET__B1a_iYfO__$_?format=webp__"